export default __webpack_public_path__ + "static/media/cards.f67f70d9.png";